<template>
  <div>
    <navigation-header></navigation-header>
    <div class="free-game-screen">
      <section class="game-main">
        <img class="free-game-img" src="/static/images/free_game.png" alt="">
        <div class="game-q-container">
          <div class="game-main__question">
            <div class="game-main__question__text">
              <p>{{ getTranslations.visitor_free_trial_new_game_question_do_you  }}
              </p>
            </div>
            <div class="game-main__question__image" :style="{
      'background-image': `url(${imgQuestion})`}"></div>
            <div class="game-main__question__text">
              <p>{{ getTranslations.visitor_free_trial_new_game_question_question   }}</p>
            </div>
          </div>
          <div class="game-main__answers">
            <div class="game-main__answers__row">
              <button v-for="(answer, index) in answerDTO"
                      :key="index"
                      class="btn select_answer"
                      :ref="index + 1"
                      :disabled="buttonPushed"
                      @click="registerUserAnswer(index)"
              >{{answer.answer}}</button>
            </div>
          </div>
        </div>
      </section>
    </div>
    <component :is="currentModal"></component>
  </div>
</template>
<script>
  /* eslint no-console: "off" */
import { mapState, mapGetters } from 'vuex';
import { Howl } from 'howler';
import NavigationHeader from '@/components/visitor/Visitor';
import PostGameTreasureBox from '@/components/visitor/freeTrial/modals/PostGameFreePlayTreasureBox';
import SpinWheel from '@/components/visitor/freeTrial/modals/SpinWheel';
import PostGameWrongAnswer from '@/components/visitor/freeTrial/modals/PostGameWrongAnswer';

export default {
  name: 'newGameFreePlay',
  components: { NavigationHeader },
  data() {
    return {
      imgQuestion: null,
      currentModal: null,
      gameWonSound: new Howl({
        src: ['static/sounds/GameWin.ogg', 'static/sounds/GameWin.mp3'],
      }),
      gameLostSound: new Howl({
        src: ['static/sounds/LoseGame.ogg', 'static/sounds/LoseGame.mp3'],
      }),
      userHasAnsweredCorrect: null,
      buttonPushed: false,
      answerDTO: [{
        answer: null,
      }, {
        answer: null,
      }],
    };
  },
  created() {
    const question = Math.floor(Math.random() * (3)) + 1;
    console.log(`given Question ${question} ...`);
    const value = this.getTranslations[`visitor_free_trial_question${question}_answer_correct`];
    console.log(value);
    this.imgQuestion = '/static/images/olympic-games-london-england.jpg';
    this.answerDTO[0].answer = this.getTranslations.visitor_free_trial_new_game_question_wrong_answer ? this.getTranslations.visitor_free_trial_new_game_question_wrong_answer : 'Costa Rica';
    this.answerDTO[1].answer = this.getTranslations.visitor_free_trial_new_game_question_correct_answer ? this.getTranslations.visitor_free_trial_new_game_question_correct_answer : 'Belize';
    this.imgQuestion = this.getTranslations.visitor_free_trial_new_game_question_photo_answer;
  },
  methods: {
    registerUserAnswer(answerId) {
      this.buttonPushed = true;
      if (answerId === 0) {
        this.userHasAnsweredCorrect = false;
        this.$refs[2][0].classList.add('correct');
        this.$refs[1][0].style.cssText = 'background-color:#ff0000 !important;';
      }
      if (answerId === 1) {
        this.userHasAnsweredCorrect = true;
        this.$refs[2][0].classList.add('correct');
      }
      this.showModal();
    },
    showModal() {
      if (this.buttonPushed) {
        setTimeout(() => {
          // wait 3 secs and show post game modal
          if (this.postGameSettings === 'SPIN_WHEEL') {
            this.currentModal = this.userHasAnsweredCorrect ? SpinWheel : PostGameWrongAnswer;
          } else if (this.postGameSettings === 'PRIZE') {
            this.currentModal = this.userHasAnsweredCorrect ? PostGameTreasureBox : PostGameWrongAnswer;
          }
          console.log('showing post game modal...');
          console.log(this.currentModal);
          this.showHideModal();
        }, 3000);
      }
    },
    showHideModal() {
      this.$nextTick(() => {
        // eslint-disable-next-line
        $('.modal,.modal-overlay').fadeIn(200);
        if (this.soundsOn) {
          if (this.userHasAnsweredCorrect) {
            this.gameWonSound.play();
          } else {
            this.gameLostSound.play();
          }
        }
        /* eslint-disable */
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          console.log('user has not leveled up, going to home page');
          this.currentModal = null;
          this.$router.push('/');
        });
      });
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'soundsOn',
      'postGameSettings',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/NewGameFreePlay.vue